import { styled } from '@mui/material';
import CustomPrimaryButton from 'components/CustomPrimaryButton/CustomPrimaryButton';


export const StyledDeleteButton = styled(CustomPrimaryButton)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.error.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));